import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useParams, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import ThankYou from "@/pages/ThankYou";
import MyToolkit from "@/pages/MyToolkit";
import CoursePage from "@/pages/CoursePage";
import { BrochureProvider } from "@/components/BrochureGate";
import Learn from "@/pages/Learn";
import { LearnAuthCallback } from "@/components/learn/LearnAuth";
import SiteHome from "@/pages/SiteHome";
import ResumeStudio from "@/pages/ResumeStudio";
import SitePrivacy from "@/pages/SitePrivacy";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import FreePage from "@/pages/FreePage";
import { isMainHost } from "@/lib/site";

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (el) { e.preventDefault(); lenis.scrollTo(el, { offset: -80 }); }
    };
    document.addEventListener("click", onClick);
    return () => { cancelAnimationFrame(id); document.removeEventListener("click", onClick); lenis.destroy(); };
  }, []);
  return null;
}

const Funnel = () => <><SmoothScroll /><Landing /></>;

// artofresume.com/go = funnel; /go/<path> forwards to /<path> (go.artofresume.com/* is redirected here by Cloudflare)
function GoRoute() {
  const rest = useParams()["*"];
  const { search, hash } = useLocation();
  return rest ? <Navigate to={`/${rest}${search}${hash}`} replace /> : <Funnel />;
}

function AppRoutes() {
  const location = useLocation();
  useEffect(() => {
    // gtag's config call tracks the first load; report later in-app navigations
    if (!window.__aorFirstView) { window.__aorFirstView = true; return; }
    window.gtag?.("event", "page_view", { page_path: location.pathname + location.search, page_location: window.location.href, send_to: "AW-18516139542" });
  }, [location.pathname, location.search]);
  if (location.hash?.startsWith("#link=")) return <LearnAuthCallback hash={location.hash} />;
  const main = isMainHost();
  return (
      <Routes>
        <Route path="/" element={main ? <SiteHome /> : <Funnel />} />
        <Route path="/go/*" element={<GoRoute />} />
        <Route path="/site" element={<SiteHome />} />
        <Route path="/resume-service" element={<ResumeStudio />} />
        <Route path="/privacy" element={<SitePrivacy />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/login" element={<Learn />} />
        <Route path="/free" element={<FreePage />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/toolkit/:id" element={<MyToolkit />} />
        <Route path="/courses/:key" element={<CoursePage />} />
        <Route path="/learn" element={<Learn />} />
      </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <BrochureProvider>
      <AppRoutes />
      <Toaster position="top-center" richColors />
      </BrochureProvider>
    </BrowserRouter>
  );
}

export default App;
